import contextBasedValue from "../misc/contextBased/contextBasedValue";
import contextBasedEnvironments from "../misc/contextBased/contextBasedEnvironments";

export default {
	baseWebserviceUrl: contextBasedValue({
		[contextBasedEnvironments.LOCAL]: 'https://localhost:7021/',
		[contextBasedEnvironments.DEV]: 'https://devapi.dvs.virginia.gov/vvs/',
		[contextBasedEnvironments.TEST]: 'https://testvvs.dvs.virginia.gov:12020/api/',				
		[contextBasedEnvironments.PROD]: 'https://vvs.dvs.virginia.gov/api/',
	}),
	basename: '/',
};
